/**
 * The one way out of a session that cannot be used any more.
 *
 * Kept apart from `panel-failure.ts`, which is `server-only`: the catalog reads this address on
 * the client too (`use-host-catalog.ts`), and a client importing the server module would fail
 * the build. The rule itself is stated there.
 *
 * `GET /api/auth/logout` deletes the session cookie before redirecting. Going straight to
 * `/onboarding` would loop: the proxy and that page still see a well-formed session cookie.
 */
export const SESSION_EXPIRED_REDIRECT = "/api/auth/logout?expired=1";
